import { types } from 'mobx-state-tree';

export const ManagerBlockModel = types
  .model('ManagerBlockModel', {
    markingManager: types.maybe(types.string),
    markingManagerMobilePhoneNumber: types.maybe(types.string),
    inspectionManager: types.maybe(types.string),
    inspectionManagerMobilePhoneNumber: types.maybe(types.string)
  })
  .volatile(() => ({
    useSameMarkingManagerAsApplicant: false,
    useSameInspectionManangerAsMarkingManager: false
  }))
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        self[key] = changedValues[key];
      }
    }
  }));
